export default {
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hello i18n !!"])},
  "copyright": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["© 2021-2024 全境智能有限公司 版權所有"])}
}